import {
   HealthcareFacilityLocationSpecialty,
   HealthcareFacilityLocationSpecialtyQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { OrderedPagination, paginations } from '@dreryk/command-query-ws-client';
import { FieldControllerProps } from '@dreryk/react-common';
import { Autosuggest, ClassNameProp } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';

const SPECIALTY_PAGINATION: OrderedPagination<
   HealthcareFacilityLocationSpecialty,
   HealthcareFacilityLocationSpecialty[]
> = paginations.all<HealthcareFacilityLocationSpecialty>().orderedBy('code', paginations.Direction.ASCENDING);

const labelExtractor = (specialty: HealthcareFacilityLocationSpecialty): string =>
   `${specialty.code.toString()} ${specialty.name}`;

const itemRenderer = (specialty: HealthcareFacilityLocationSpecialty): JSX.Element => (
   <div>{`${specialty.code.toString()} ${specialty.name}`}</div>
);

export const healthcareFacilityLocationSpecialtySearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<HealthcareFacilityLocationSpecialty[]> =>
      performCqrsQuerySearch<HealthcareFacilityLocationSpecialty>(() => {
         const query = new HealthcareFacilityLocationSpecialtyQuery();
         if (searchText) {
            query.nameOrCode = TextPattern.anywhereIgnoreCase(searchText);
         }
         return query;
      }, SPECIALTY_PAGINATION);
};

type SpecialtyAutosuggestProps = FieldControllerProps<'specialty', HealthcareFacilityLocationSpecialty | null> &
   ClassNameProp;

export const SpecialtyAutosuggest = (props: SpecialtyAutosuggestProps): JSX.Element => {
   const controller = props.register(props.name, { required: props.required });

   return (
      <Autosuggest<HealthcareFacilityLocationSpecialty>
         label={healthcareOrganizationTranslationKeys.resortCode.eight}
         placeholder={healthcareOrganizationTranslationKeys.insertSpecialty}
         minChars={3}
         labelExtractor={labelExtractor}
         itemRenderer={itemRenderer}
         searchCreator={healthcareFacilityLocationSpecialtySearchCreator}
         keyProperty={'id'}
         controller={controller}
         testId={props.name}
         className={props.className}
      />
   );
};
